import React, { ReactNode } from "react"
import { Box } from "@chakra-ui/react"
import { SYSTEM_FONT } from "utilities/fitFontSize"

type Props = {
  backgroundUrl: string
  accent: string
  children: ReactNode
}

/**
 * Background shared by both kiosk screens.
 * - No image: vertical gradient — solid black from 0–60% of the height, fading from
 *   black into the accent color across 60–100%.
 * - Image: aspect-filled with a 32% black overlay.
 *
 * Renders all kiosk text in the system font (≈ iOS SF Pro) rather than the app's brand
 * font, so the preview matches the real iPad and the text wraps exactly where `fitText`
 * (which measures in the same font) predicts.
 */
const KioskPreviewBackdrop = ({ backgroundUrl, accent, children }: Props) => (
  <Box w="100%" h="100%" position="relative" fontFamily={SYSTEM_FONT}>
    {backgroundUrl ? (
      <>
        <Box
          position="absolute"
          inset={0}
          backgroundImage={`url(${backgroundUrl})`}
          backgroundSize="cover"
          backgroundPosition="center"
        />
        <Box position="absolute" inset={0} bg="rgba(0, 0, 0, 0.32)" pointerEvents="none" />
      </>
    ) : (
      <Box
        position="absolute"
        inset={0}
        sx={{
          background: `linear-gradient(to bottom, #000000 0%, #000000 60%, ${accent} 100%)`,
        }}
      />
    )}
    {children}
  </Box>
)

export default KioskPreviewBackdrop
